<template>
  <div class="app-wrapper hideSidebar">
    <div class="content-container">
      <screen-main />
    </div>
  </div>
</template>

<script>
import ScreenMain from './components/ScreenMain.vue'
export default {
  name: 'ScreenLayout',
  components: {
    ScreenMain
  }
}
</script>

<style lang="scss" scoped>
  @import "../Layout/mixin";
  @import "../Layout/variables.scss";

  .content-container {
    display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;

  }

  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    width: calc(100% - 80px);
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    transition: width 0.28s;
  }
</style>
